/* hayakmodule */
define( 'journeyhayak',[ 'jquery' ],
	function ( $ ) {

		'use strict';

		/**
		 * Iterates over all $journeys and initiates journey controller.
		 */

		return {

			init: function ( $journeys ) {

				// if initComponent was invoked, use $journeys. otherwise it's the bootstrap init call
				if ( typeof( $journeys ) === 'undefined' ) {

					$journeys = $( '[ data-journey ]' );

				}

				$journeys.each( function () {

					var $journey = $( this ),
						id = $journey.data( 'journey' );

					//Retrieves the id of the module from the 'journey' data attribute and calls the relevant controller.
					require( [ '../src/hayak/journeys/' + id + '/' + id ], function ( Journey ) {

						var journey;

						if ( Journey !== undefined ) {

							journey = new Journey( $journey );
							journey.init();
						}
					} );
				} );
			}
		};
	} );

